/**
 * Lalay user stats — wraps /wp-json/lalay/v1/stats.
 * Returns { totalOrders, totalSpent, joinDate, phone } from WC.
 */

import { getToken } from './auth';

const BASE = '/wp-json/lalay/v1';

export async function fetchUserStats() {
  const tok = getToken();
  if (!tok) return null;
  try {
    const res = await fetch(`${BASE}/stats`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tok}` },
    });
    const body = await res.json().catch(() => null);
    if (res.ok && body?.success) return body.stats || null;
  } catch {}
  return null;
}
